import { getNamespaced } from '@/store/utils';

/* eslint-disable import/prefer-default-export, key-spacing */

export const session = {
  recall:   'RECALL_SESSION',
  setToken: 'SET_TOKEN',
};
export const sessionNS = getNamespaced('session', session);

export const distributor = {
  getDistributor:   'GET_DISTRIBUTOR',
};

export const distributorNS = getNamespaced('distributor', distributor);

export const googlemap = {
  markAllDealers:         'MARK_ALL_DEALERS',
};

export const googlemapNS = getNamespaced('googlemap', googlemap);



// WEBPACK FOOTER //
// ./src/store/types/actions.js